import { useMutation } from 'react-query';
import { ICreateOrder } from '../../../../../orders/Entities';
import OrdersApi, { CreateOrderResult } from '../../../../../orders/OrdersApi';
import { PhotographerBookingParamsStorageKey } from '../adapters/dataSharingBetweenNavigation';
import { createCalendarItem } from '../../shared/bookingDateSelect/state/dateHelper';

export function useCreateOrderMutation(
    orderInformation: ICreateOrder,
    onSuccess: (result: CreateOrderResult) => void
) {
    return useMutation(
        ({
            timeslot,
            photographerId
        }: {
            timeslot: string;
            photographerId: number;
        }): Promise<CreateOrderResult> => {
            return OrdersApi.createOrder(
                {
                    ...orderInformation,
                    // @ts-ignore
                    calendarItem: createCalendarItem(photographerId, timeslot)
                },
                false
            );
        },
        {
            onSuccess: (result: CreateOrderResult) => {
                window.localStorage.removeItem(PhotographerBookingParamsStorageKey);
                onSuccess(result);
            }
        }
    );
}
